import React, { useRef, useState, useEffect } from 'react'
import { Button, Form } from 'semantic-ui-react'
import useModal from 'hooks/useModal'

export default function WebEmbedSurveyHeaderActionButton({ survey }) {
  const { open: openEmbedCodeModal, Modal: EmbedCodeModal } = useModal()

  return (
    <React.Fragment>
      <Button className="!mr-1" onClick={openEmbedCodeModal}>
        Get embed code
      </Button>
      <EmbedCodeModal size="small">
        <EmbedCodeModal.Header>Install your web-embed survey</EmbedCodeModal.Header>
        <EmbedCodeModal.Content>
          <a
            href="https://help.simplesat.io/en/articles/8094151-web-embed-surveys#install-a-web-embed-survey"
            target="_blank"
            rel="noopener"
          >
            <i className="icon far fa-book" />
            How to add web-embed surveys to your website
          </a>
          <h3>Step 1 - Copy the embed script</h3>
          <p>
            Replace the predefined customer information with fields from your app. Include
            additional fields like customer attributes, ticket details, booking ID, or page info, as
            needed.
          </p>
          <EmbedCodeSnippet survey={survey} />
          <h3>Step 2 - Add the code to your website</h3>
          <p>Paste the code directly on your website where you'd like survey to be displayed.</p>
          <p>
            You might need your website developer to help out with this. If you have any questions,
            feel free to reach out to the Simplesat team for help.
          </p>
        </EmbedCodeModal.Content>
      </EmbedCodeModal>
    </React.Fragment>
  )
}

const EmbedCodeSnippet = ({ survey }) => {
  const surveyToken = survey.token
  const embedScript = `<script id="simplesat-web-embed" src="${process.env.REACT_APP_EMBED_SCRIPT_URL}"></script>
<script>
  window.addEventListener("load", function renderSurvey(event){
      simplesat.survey({
        survey_token: "${surveyToken}",
        customer: {
          email: "tester@example.com",
          name: "Tester McTestface",
        }
      })
  })
</script>`

  const embedCodeRef = useRef()
  function selectCode(e) {
    e.target.select()
  }
  return (
    <Form>
      <Form.Field>
        <textarea
          ref={embedCodeRef}
          readOnly
          rows={12}
          className="w-full"
          value={embedScript}
          onClick={selectCode}
        />
      </Form.Field>
      <CopyEmbedCodeButton embedCodeRef={embedCodeRef} />
    </Form>
  )
}

const CopyEmbedCodeButton = ({ embedCodeRef }) => {
  const TIMEOUT_MS = 2000
  const [overriddenButtonLabel, setOverriddenButtonLabel] = useDisappearingText('', TIMEOUT_MS)

  function handleClick() {
    copyWidgetCode()
    setOverriddenButtonLabel('Copied!')
  }

  function copyWidgetCode() {
    // Newer standard to replace `execCommand`
    if (navigator.clipboard && embedCodeRef.current) {
      navigator.clipboard.writeText(embedCodeRef.current.value)
    } else {
      embedCodeRef.current.select()
      document.execCommand('copy')
    }
  }

  return (
    <Button size="large" fluid primary onClick={handleClick}>
      {overriddenButtonLabel || 'Copy survey code'}
    </Button>
  )
}

function useDisappearingText(initialText, timeout) {
  const [text, setText] = useState(initialText)
  const initialTimerId = 0
  const timerRef = useRef(initialTimerId)

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  function setTextWithTimeout(text) {
    setText(text)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setText('')
    }, timeout)
  }

  return [text, setTextWithTimeout]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/WebEmbedSurveyHeaderActionButton/index.js